// A ROW SITTING UNDER A NAME IT DOES NOT CALL ITSELF.
//
// Owner, 2026-10-02: "Show both names on the row." Rows STAY where the
// records put them - nothing moves, nothing is invented - and each row
// carries the MODEL's own name beside the record one where the two differ.
//
// WHY A ROW CAN BE UNDER ANOTHER NAME AT ALL: an element row carries two
// taxonomies. `c` is what the element calls itself (the model's category);
// `rc` is the record tree the scope was picked from. They usually agree.
// On SpaceX BA03 they disagree on 48,169 of 339,354 rows - measured, not
// guessed - across seven pairs:
//   MEP Fabrication Pipework / Insulation   43,015
//   MEP Fabrication Ductwork / Lining        4,836
//   Stairs / Supports                          150   (stair stringers)
//   Railings / Top Rails 63, Railings / Handrails 49
//   Stairs / Runs 36, Stairs / Landings 20
// Since a ticked category is now matched against BOTH, ticking "Supports"
// finds its 150 rows - and they appear under Stairs. This label is what
// explains that.
//
// FOUR CONSTRAINTS, all the leader's and all of them earned:
//
// 1. ONLY WHEN THE NAMES DIFFER. 291,185 rows have rc === c, so printing
//    the same word twice on 86% of the tree is noise that would get the
//    feature switched off.
// 2. FROM THE ROW'S OWN DATA, NEVER A MAP. The row already carries `c`.
//    The moment anybody writes a Supports-means-Stairs table it is wrong
//    on the next export and wrong in SILENCE.
// 3. PER ROW, NOT PER GROUP. Stairs contains Supports 150, Runs 36 AND
//    Landings 20 - three model categories under one record name - so a
//    single second label at group level would be a plain lie. The group is
//    left alone.
// 4. IT IS A FACT, NOT A REASSURANCE, and this is the one I would have got
//    subtly wrong. "The model calls this Supports" is a fact. Anything
//    like "also counted under Supports" implies a SECOND COUNT that does
//    not exist: one row per element, one count, which is exactly what the
//    unique index guarantees and what the measurement established. The
//    label must not undo it. The test pins the wording so it cannot drift
//    into the reassuring form.

// The model's own name for this row, when it is worth saying. "" otherwise.
//
// `branch` is the record category the row is sitting under - the tree node
// it was drilled into. A row whose own category matches its branch has
// nothing to explain.
export function modelNameFor(row, branch) {
  const own = String((row && row.category) || "").trim();
  const under = String(branch || "").trim();
  if (!own || !under) return "";
  if (own === under) return "";
  return own;
}

// What the label says, in full. Kept beside the rule so the wording and
// the condition cannot drift apart.
export function modelNameTooltip(row, branch) {
  const own = modelNameFor(row, branch);
  if (!own) return "";
  return `The model calls this "${own}". It is listed under "${String(branch).trim()}" because that is where the record data files it.`;
}
